import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { navDelay, loaderDelay } from '@utils';
import { usePrefersReducedMotion } from '@hooks';

const StyledHeroSection = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  height: 100vh;
  padding: 0;

  @media (max-height: 700px) and (min-width: 700px), (max-width: 360px) {
    height: auto;
    padding-top: var(--nav-height);
  }

  h1 {
    margin: 0 0 30px 4px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h3 {
    margin-top: 5px;
    color: var(--slate);
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: 540px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, []);

  const one = <h1>こんにちは、私の名前は</h1>;
  const two = <h2 className="big-heading">張 路暘 (Luyang Zhang).</h2>;
  const three = <h3 className="big-heading">AIとクラウドを繋ぐエンジニア。</h3>;
  const four = (
    <>
      <p>
        中国出身・日本在住のAI／クラウドエンジニアです。
        <a href="https://www.nagoya-u.ac.jp/" target="_blank" rel="noreferrer">
          名古屋大学大学院
        </a>
        にて医用画像解析の研究で
        <a href="https://www.nagoya-u.ac.jp/" target="_blank" rel="noreferrer">
          博士号
        </a>
        を取得後、現在は
        {' '}
        <a href="https://www.astemo.com/" target="_blank" rel="noreferrer">
          株式会社Astemo
        </a>
        {' '}
        にてクラウド基盤・AIシステム・シミュレーション環境の開発・運用に携わっています。
        医療画像AI（CT/MRI/内視鏡）・VLM・少数アノテーション学習・AWS/Kubernetesが専門領域です。
      </p>
    </>
  );
  const five = (
    <a
      className="email-link"
      href="mailto:zlytoyko@gmail.com">
      Get In Touch
    </a>
  );

  const items = [one, two, three, four, five];

  return (
    <StyledHeroSection>
      {prefersReducedMotion ? (
        <>
          {items.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </>
      ) : (
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
              </CSSTransition>
            ))}
        </TransitionGroup>
      )}
    </StyledHeroSection>
  );
};

export default Hero;
